export default class RiskFactor {
    constructor(data) {
        this.name = this.constructor.name;
        this.condition = !!this.constructor.getCondition(data);
        this.className = null;
        this.icon = null;
        this.label = null;

        if (this.condition) {
            this.parse(data);
        }
    }

    /**
     * Get condition. Returns boolean value of risk-factor condition.
     * If it's true - factor will be parsed and results will be returns
     *
     * @param {object} data - constructor data.
     * @returns {boolean}
     */
    // eslint-disable-next-line no-unused-vars
    static getCondition(data) {
        throw new Error(`Method getCondition must be implemented in extended factor ${this.prototype.constructor.name}`);
    }

    isAvailable() {
        return this.condition;
    }

    /**
     * Method for parsing constructor initial data.
     * In this method you should set class properties.
     * This method will called only if getCondition returns true
     *
     * @param {object} data - constructor data.
     */
    // eslint-disable-next-line no-unused-vars
    parse(data) {
        throw new Error(`Method parse must be implemented in extended factor ${this.constructor.name}`);
    }

    /**
     * Returns string value of risk-factor analysis
     *
     * @returns {string}
     */
    getResult() {
        throw new Error(`Method getResult must be implemented in extended factor. ${this.constructor.name}`);
    }

    getAnalysis() {
        return {
            icon: this.icon,
            label: this.label,
            class: this.className,
            result: this.getResult(),
        };
    }
}
